import { GroupContextSchemaData, UserContextSchemaData } from '../schema'
import { trackEvent } from './helper'

type GroupEventParams = {
  group: GroupContextSchemaData
}

export const draft_group = () => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'draft_group',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })
}

export const create_group = (props: GroupEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'create_group',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const request_join_group = (props: GroupEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'request_join_group',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const join_group = (props: GroupEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'join_group',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const open_member_list = (props: GroupEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'open_member_list',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const open_highlights = (props: GroupEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'open_highlights',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const open_related_groups = (props: GroupEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'open_related_groups',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const open_walkthrough = (props: GroupEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'open_walkthrough',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const transfer_ownership = (
  props: GroupEventParams & { user: UserContextSchemaData }
) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'transfer_ownership',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const add_moderator = (
  props: GroupEventParams & { users: UserContextSchemaData[] }
) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'add_moderator',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const edit_group = (props: GroupEventParams) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'edit',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const ban_group_user = (
  props: GroupEventParams & { user: UserContextSchemaData }
) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'ban',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}

export const add_related_groups = (
  props: GroupEventParams & { groups: GroupContextSchemaData[] }
) => {
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'add_related_groups',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })
}
